/**
 * Get CSRF token from meta tag
 * @returns {string|null} The CSRF token or null if not found
 */
export function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

/**
 * Make an API request with CSRF token and JSON headers
 * @param {string} url - The URL to fetch
 * @param {Object} options - Fetch options (method, body, etc.)
 * @returns {Promise<Object>} The JSON response
 */
export async function apiRequest(url, options = {}) {
  const csrfToken = getCsrfToken()

  if (!csrfToken) {
    throw new Error('CSRF token not found')
  }

  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      ...options.headers
    },
    ...options
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}

/**
 * Make a POST request with JSON body
 * @param {string} url - The URL to post to
 * @param {Object} data - The data to send as JSON
 * @returns {Promise<Object>} The JSON response
 */
export async function postJson(url, data) {
  return apiRequest(url, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * Make a DELETE request
 * @param {string} url - The URL to delete
 * @returns {Promise<Object>} The JSON response
 */
export async function deleteRequest(url) {
  return apiRequest(url, {
    method: 'DELETE'
  })
}
